import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { useEffect, useState } from "react";
import * as Animate from "react-reveal";
import LearnPlaceholderImage from "../../../assets/images/png/courses/learn.webp";
import { getCoursesApi } from "../../../store/actions";
import learningDataAfrica from "../../individual/components/data/learningDataAfrica";
import learningDataEurope from "../../individual/components/data/learningDataEurope";

const Card = ({ course }) => {
  return (
    <div className="bg-white w-full bg-white2 card rounded-xl h-full">
      <a
        href={course?.url}
        target="_blank"
        rel="noopener noreferrer"
        className=""
      >
        <div className="card-header rounded-tl-xl rounded-tr-xl">
          <img src={course?.image} alt="" />
        </div>

        <div className="px-6 py-10 rounded-b-xl">
          <div className="mb-4 text-xs leading-5 flex flex-wrap space-x-2">
            <div className="tag-primary px-2 rounded-sm">
              <p>{course?.courseType}</p>
            </div>
            <div className="tag-secondary px-2 rounded-sm">
              <p>{course?.courseLevel}</p>
            </div>
          </div>
          <h3 className="xl:pr-4 font-mono font-semibold text-default text-lg lg:text-xl">
            {course?.title}
          </h3>
        </div>
      </a>
    </div>
  );
};

const SkeletonCard = () => {
  return (
    <div
      className="bg-white w-full bg-white2 card rounded-xl h-80 overflow-hidden"
      aria-hidden="true"
    >
      <div className="rounded-tl-xl rounded-tr-xl">
        <div className="h-44 w-full bg-primary-light-2 animate-pulse" />
      </div>
      <div className="px-6 py-10 rounded-b-xl">
        <div className="mb-4 flex flex-wrap space-x-2">
          <div className="h-5 w-24 bg-gray-30 rounded-sm animate-pulse" />
          <div className="h-5 w-16 bg-gray-30 rounded-sm animate-pulse" />
        </div>
        <div className="space-y-3">
          <div className="h-5 w-11/12 bg-gray-30 rounded animate-pulse" />
          <div className="h-5 w-8/12 bg-gray-30 rounded animate-pulse" />
        </div>
      </div>
    </div>
  );
};

const LearningSection = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const fetchData = async () => {
    setLoading(true);
    try {
      const params = {
        page: 1,
        limit: 20,
      };

      const response = await getCoursesApi(params);
      // console.log(response);
      setCourses(response?.data || []);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const skeletonItems = Array.from({ length: 8 }, (_, idx) => idx);
  const getCourseData = (course, index) => {
    const images = [...learningDataAfrica, ...learningDataEurope].filter(
      (item) => item?.image
    );
    const imageIndex = images.length ? index % images.length : 0;
    const selectedImage = images[imageIndex]?.image;

    return {
      id: course?._id || index,
      image: selectedImage || LearnPlaceholderImage,
      title: course?.title,
      url: course?.enrolLink,
      courseType: "For Early Professionals",
      courseLevel: "3 Months",
    };
  };

  const data = (courses || []).map(getCourseData);

  if (!loading && (!courses || courses?.length === 0)) {
    return null;
  }

  return (
    <section id="kickstart" className="pt-20 lg:pt-24 pb-24 lg:pb-28">
      <div className="container mx-auto px-4">
        <div className="w-full lg:w-8/12 xl:w-6/12">
          <Animate.Fade bottom>
            <h2 className="text-primary text-3xl lg:text-4xl xl:text-5xl xl:leading-tight font-mono font-semibold">
              What is the Best Learning Program for You?
            </h2>

            <p className="mt-6 text-sm-15 lg:text-base xl:text-lg lg:leading-7">
              Top courses people are learning
            </p>
          </Animate.Fade>
        </div>

        <div className="mt-6 lg:mt-10">
          {loading ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
              {skeletonItems.map((idx) => (
                <SkeletonCard key={`sk-${idx}`} />
              ))}
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-4 gap-y-8">
              {data.map((course, idx) => {
                return (
                  <Card
                    key={course?.id || course?.title || idx}
                    course={course}
                  />
                );
              })}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default LearningSection;
